// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"85c3a8d2","751":"85c3a8d2","846":"85c3a8d2"}[chunkId] + ".chunk.css";
};